import { Navigate, Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { AuthContextValue, useApiState } from '../contexts/ApiContext';

function NotFound() {
  const state = useApiState();
  switch (state) {
    case 'loading':
      return null;
    case 'authenticated':
      return <Navigate to="/account/home" replace />;
    default:
      return <Navigate to="/auth" replace />;
  }
}

export interface RouterContext {
  api: AuthContextValue;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  notFoundComponent: NotFound,
});
